import { render, staticRenderFns } from "./DefinePassword.vue?vue&type=template&id=5171fb6c"
import script from "./DefinePassword.vue?vue&type=script&lang=js"
export * from "./DefinePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports